export enum EDistributionContractType {
    PERCENTAGE = 1,
    FIXED_AMOUNT = 2,
}

export const getDistributionContractTypeDescription = (type: number | null | undefined): string => {
    switch (type) {
        case EDistributionContractType.PERCENTAGE:
            return 'Porcentual';
        case EDistributionContractType.FIXED_AMOUNT:
            return 'Importe fijo';
        default:
            return '—';
    }
};
